// extracted by mini-css-extract-plugin
module.exports = {"modalBody":"InviteForm__modalBody--13uHU Modal__body--1m45q","caution":"InviteForm__caution--2KA-p"};